/*
 * @Description: 优惠券列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-06-28 10:04:15
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Divider, message, Popconfirm} from 'antd';
import PageWrap from '../../../components/PageWrap';
import SuperForm from '../../../components/SuperForm';
import TableDOM from '../../../components/Table';
import AuthButton from '../../../components/AuthButton/AuthButton';
import Detail from './Detail';
import {postFrom, config, post} from '../../../axios';
import {formatTime, moneyAddComma} from '../../../utils/index'
import {dicDiscountCouponLogStatus, dicPayType} from '../../../axios/dictionaries';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',          //关键字
                pageSize: 10,
                payType:'',
                mustPayDate:''
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            showDetailModal: false, //显示详情
            tableTotal: 0, //表格总数据量
            showAddModal: false, //显示新增/编辑
        }
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showDetailModal,
            showAddModal,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ handleEdit: this.handleEdit,handleEditStatus:this.handleEditStatus,handleShowDetail: this.handleShowDetail })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />

                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />

            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleShowDetail = (id) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(id);
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_coupon_log_findPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }
}

const searchData = () => [
    {
        tagName: 'MonthPicker',
        formConfig: { name: 'mustPayDate' },
        attribute: { placeholder: '请选择生效月份',type:'month',format:"YYYY-MM", style: { width: "172.7px" } },
    },
    {
        tagName: 'Select',
        formConfig: { name: 'payType' },
        attribute: { placeholder: '请选择支付类型', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(dicPayType.filter(item => (item.value ===3)||(item.value ===7))),
        notResult: '',
    },
    {
        tagName: 'Select',
        formConfig: { name: 'status' },
        attribute: { placeholder: '请选择优惠券使用状态', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(dicDiscountCouponLogStatus),
        notResult: '',
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: '在优惠券名称及账单费项内模糊查询'
    },

];

const columns = ({ handleEdit , handleEditStatus,handleShowDetail}) => [
    {
        title: '优惠券名称',
        dataIndex: 'couponName',
    },
    {
        title: '账单费项',
        dataIndex: 'feeName',
    },
    {
        title: '支付方式',
        dataIndex: 'payType',
        render(text){
            if(text){
                let now = dicPayType.find(item => item.value === text);
                if (now)
                    return <span>{now.title}</span>;
            }else{
                return "";
            }


        }
    },
    {
        title: '生效月份',
        dataIndex: 'mustPayDate',
    },
    {
        title: '减免金额',
        dataIndex: 'creditAmount',
        render(text){
            return moneyAddComma(text);
        }
    },
    {
        title: '租客',
        dataIndex: 'customerName',
    },
    {
        title: '租客手机',
        dataIndex: 'customerPhone',
    },
    {
        title: '领取时间',
        dataIndex: 'createTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '优惠券状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicDiscountCouponLogStatus.find(item => item.value === text);
            if (now){
                return <span style={{ color: now.color }}>{now.title}</span>;
            }

            return null
        }
    },
    {
        title: '核销时间',
        dataIndex: 'verificationTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '操作',
        dataIndex: 'status',
        render(text, record, index) {
            return (
                text?text!=3?"-":  <span className="showClickDetail"  onClick={() => { handleShowDetail(record.billId) }} style={{ margin: '0 10px 0 0' }}>{'查看核销账单'}</span>:'-'
            )
        }
    },
];



// WEBPACK FOOTER //
// ./src/page/Coupons/log/List.js